import styled from 'styled-components';

const CopyIcon = styled.div`
  padding-left: 10px;
`;

export default CopyIcon;
